<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct1p" id="p0013-01-0"><a id="page7"></a><a href="#/contents#fn_6" id="sn_6">DAY 6</a></p>
<p class="ct1"><a href="#/contents#fn_6">GOD’S HANDIWORK</a></p>
<p class="ext"><span><i>So God created mankind in his own image, in the image of God he created them; male and female he created them.</i></span></p>
<p class="txr"><span><span class="small">GENESIS</span> 1:27</span></p>
<p class="tx1" id="p0013-04-4"><span class="dcap">Y</span>ou are created in God’s own image. You are not a biological accident. You are not some beating-the-infinite-odds chance arrangement of cells into organs into systems into a body.</p>
<p class="tx">No, you are created and crafted. You are “God’s handiwork” (Ephesians 2:10). And he created not only your body, but he “created [your] inmost being” (Psalm 139:13). And the model for this work of art? Himself. You are created in God’s image.</p>
<p class="tx">This image is not physical. God’s image is reflected in our “inmost being,” in our abilities to think and reason, understand good and evil, create and invent, make choices, appreciate beauty, be in relationship, have a sense of justice, and love.</p>
<p class="tx">And this image of God is reflected in every human being, in our enemies as well as our neighbors. May we see everyone around us as God sees them: as his precious handiwork.</p>
<p class="tx3">CREATED IN GOD’S IMAGE, MAY WE LIVE—MAY WE SPEAK, ACT, INTERACT—IN A WAY THAT HONORS HIM AND REFLECTS HIS IMAGE.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter9.vue?0c78dab5